module.exports = __webpack_public_path__ + "static/img/img_02.f6de8ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/img_02.jpg
// module id = 6enI
// module chunks = 96